<template>
	<div class="app-store-cta">
		<div class="cta__column">
			<h1>
				Fighting blood cancer with the most entertaining check-out process
			</h1>
			<p>
				We knew, that 91% of online donations in the charity failed during the check-out process.
				<br><br>
				So, we made ours part of the fun. With the game-like shopping experience 60% followed through on their purchase - a 439% improvement compared to average.
			</p>

			<a class="cta__column-button" target="_blank" value="www.helfen-mit-style.de" href="https://www.helfen-mit-style.de/info">
				Visit shop
			</a>
		</div>
		<div class="cta__column">

			<div class="phone__container">
				<video src="@/assets/ScreenFuerWeb_699hoch_1.mp4" autoplay="autoplay" loop="loop" class="phone__container-video" muted="muted"></video>
				<span class="phone__container-frame">
					<svg id="Layer_1" data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 380 781"><path
						d="M373.83 175.31h-1V45.71a42 42 0 0 0-42-42H48.7a42 42 0 0 0-42 42v63.71h-1a2.65 2.65 0 0 0-2.63 2.64V136a2.63 2.63 0 0 0 2.63 2.63h1v36.71h-1A2.64 2.64 0 0 0 3.06 178v48.85a2.65 2.65 0 0 0 2.63 2.64h1V244h-1a2.65 2.65 0 0 0-2.63 2.64v48.83A2.64 2.64 0 0 0 5.69 298h1v437.56a42 42 0 0 0 42 42h282.14a42 42 0 0 0 42-42V298h1a2.64 2.64 0 0 0 2.64-2.64V178a2.64 2.64 0 0 0-2.59-2.69zm-10.68 560.25a32.36 32.36 0 0 1-32.32 32.32H48.7a32.36 32.36 0 0 1-32.32-32.32V45.71A32.36 32.36 0 0 1 48.7 13.39h43.81v4.53a51 51 0 0 0 .12 5.53 21 21 0 0 0 20.72 18.27h154.53a19.27 19.27 0 0 0 4.08-.4c6.62-1.46 11.06-5.57 13.77-11.67a23.84 23.84 0 0 0 1.7-10.82v-5.44h43.4a32.36 32.36 0 0 1 32.32 32.32z"
						fill="#010101"></path>
						<path
						d="M330.83 3.7a42 42 0 0 1 42 42v129.6h1a2.64 2.64 0 0 1 2.64 2.64v117.45a2.64 2.64 0 0 1-2.64 2.64h-1v437.53a42 42 0 0 1-42 42H48.7a42 42 0 0 1-42-42V298h-1a2.65 2.65 0 0 1-2.63-2.64v-48.8a2.65 2.65 0 0 1 2.63-2.64h1v-14.5h-1a2.65 2.65 0 0 1-2.63-2.64V178a2.65 2.65 0 0 1 2.63-2.64h1V138.6h-1a2.64 2.64 0 0 1-2.64-2.6v-23.94a2.65 2.65 0 0 1 2.63-2.64h1V45.71a42 42 0 0 1 42-42h282.14m0-3.3H48.7a45.36 45.36 0 0 0-45.31 45.3v60.88a5.94 5.94 0 0 0-3.63 5.47V136a5.93 5.93 0 0 0 3.63 5.46v31A5.94 5.94 0 0 0-.24 178v48.83a5.93 5.93 0 0 0 3.63 5.46v8.86a5.93 5.93 0 0 0-3.63 5.46v48.83a5.94 5.94 0 0 0 3.63 5.47v434.7a45.37 45.37 0 0 0 45.31 45.26h282.13a45.37 45.37 0 0 0 45.31-45.31v-434.7a6 6 0 0 0 3.62-5.47V178a6 6 0 0 0-3.62-5.47V45.71A45.37 45.37 0 0 0 330.83.4z"
						fill="#4b4a4b"></path>
						<path
						d="M129 750.25a2.5 2.5 0 0 1 0-5l126.5-.25a2.5 2.5 0 0 1 0 5l-126.5.25z" fill="#fff"
						opacity=".6"></path>
					</svg>
				</span>
			</div>

		</div>
	</div>
</template>

<script>
    export default {
        name: 'app-store-cta',
    }

</script>

<style lang="scss" scoped>
	.app-store-cta {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #fff;
		padding: 0 5%;

		@media screen and (min-width: 768px) {
			flex-wrap: nowrap;
		}
	}

	.cta__column {
		flex-basis: 100%;
		text-align: center;
		padding: 10% 8%;

		@media screen and (min-width: 768px) {
			padding: 10% 6%;
		}

		img {
			height: auto;
			max-width: 80%;
			min-width: 50%;
		}


		h1 {
			font-size: 2.7rem;
			font-family: dkms1;
			margin-bottom: 10%;
			text-align: left;
			font-weight: bold;
			text-transform: uppercase;
			padding-top: 10%;
			letter-spacing: .7px;

			@media screen and (max-width: 768px) {
				font-size: 2.2rem;
			}
		}

		p {
			text-align: left;
			margin-bottom: 10%;
			font-size: 1.2rem;
			color: #303030;

			@media screen and (max-width: 768px) {
				font-size: 1.1rem;
			}
		}

		&-button {
			font-family: dkms1;
			text-transform: uppercase;
			width: 100%;
			background-color: #B9271A;
			border: none;
			color: white;
			text-align: center;
			text-decoration: none;
			display: inline-block;
			font-size: 2.7rem;
			letter-spacing: 1px;
			padding: 7% 0;
			cursor: pointer;
			border: 4px solid !important;
			border-color: transparent;
			&:hover,
			&:active {
				color: #B9271A!important;
				background: transparent;
				border: 4px solid #B9271A !important;
				transition: all 0.4s ease 0s;
			}

			@media screen and (max-width: 768px) {
				font-size: 2.1rem;
			}

		}
	}

	.phone__container {
		-ms-flex-negative: 0;
		flex-shrink: 0;
		margin: 0 auto;
		transform: matrix(1, 0, 0, 1, 0, 0);
		margin-top: 15%;

		@media screen and (max-width: 1200px) {
			margin-top: 35%;
		}

		@media screen and (max-width: 1024px) {
			margin-top: 30%;
		}

		@media screen and (max-width: 767px) {
			margin-top: 0;
		}


			&-video {
				position: absolute;
				width: 55%;
				left: 50%;
				-webkit-transform: translateX(-50%);
				transform: translateX(-50%);
				top: 2%;

				@media screen and (max-width: 1200px) {
					width: 70%;
				}

				@media screen and (max-width: 1024px) {
					width: 85%;
				}

				@media screen and (max-width: 767px) {
					width: 60%;
				}
			}

			&-frame {
				position: relative;
				width: 60%;
				display: inline-block;
				vertical-align: middle;

				@media screen and (max-width: 1200px) {
					width: 75%;
				}

				@media screen and (max-width: 1024px) {
					width: 90%;
				}

				@media screen and (max-width: 767px) {
					width: 65%;
				}


			}

			svg {
				pointer-events: none;
			}
	}

</style>
